/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Advanced_TitleInputs */

const cs_builder_advanced_title = /** @type {(inputs: Builder_Advanced_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokročilé Typst`)
};

const en_builder_advanced_title = /** @type {(inputs: Builder_Advanced_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced Typst`)
};

/**
* | output |
* | --- |
* | "Advanced Typst" |
*
* @param {Builder_Advanced_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_advanced_title = /** @type {((inputs?: Builder_Advanced_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Advanced_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_advanced_title(inputs)
	return cs_builder_advanced_title(inputs)
});